import { Link } from "react-router-dom";
import PageIntro from "@/components/PageIntro";

export default function NotFound() {
  return (
    <div>
      <PageIntro
        eyebrow="404"
        title="This ritual wandered off"
        description="The page you're looking for isn't here. Let's find your way back."
      >
        <Link to="/" className="mt-8 inline-flex btn btn-primary">
          Back to home
        </Link>
      </PageIntro>
    </div>
  );
}
